import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { SellCustomer } from "../../models/sell-customer.model";

@Component({
  selector: "ngx-sell-customer-form",
  templateUrl: "./sell-customer-form.component.html",
  styleUrls: ["./sell-customer-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SellCustomerFormComponent extends BaseFormComponent<SellCustomer> {
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.apiName = "SellCustomer";
    this.label = "مشتری";
    super.ngOnInit();
  }
  setdefault() {
    if (!this.model.StartDate) this.model.StartDate = new Date();
    if (this.model.BranchId === undefined) this.model.BranchId = this.accountService.authService.currentBranchId;
    if (this.model.Active === undefined) this.model.Active = true;
    if (this.model.IsPermanent === undefined) this.model.IsPermanent = true;
    if (this.model.IsBlacklist === undefined) this.model.IsBlacklist = false;
    if (this.model.ConsumedCredit === undefined) this.model.ConsumedCredit = 0;
    if (this.model.DocumentCredit === undefined) this.model.DocumentCredit = 0;
  }
  onChanged($event) {
    if ($event.apiName && $event.data && $event.data.Id && $event.apiName.includes("PeopleInfo/GetPagining")) {
      this.formGroup.controls["Number"].setValue($event.data.Number);
      this.model.Number = $event.data.Number;
    }
  }
  addControl() {}
}
